"use client";

import * as React from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Patienttestimonials() {
  const heroReveal = useRevealOnScroll<HTMLDivElement>();
  const headerReveal = useRevealOnScroll<HTMLDivElement>();
  const carouselReveal = useRevealOnScroll<HTMLDivElement>();
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  const secondaryTestimonials = [{
    quote: "La atención personalizada y el rigor médico de la Dra. Soto me devolvieron la confianza que había perdido hace años.",
    author: "CARLOS M.",
    meta: "TRATAMIENTO DE DENSIDAD"
  }, {
    quote: "Un proceso impecable. Desde la primera consulta hasta el seguimiento, me sentí en manos de una verdadera experta.",
    author: "ELENA R.",
    meta: "FORTALECIMIENTO CAPILAR"
  }, {
    quote: "Resultados naturales y un trato humano excepcional. No podría estar más satisfecho con la decisión de elegir este instituto.",
    author: "JAVIER G.",
    meta: "CIRUGÍA CAPILAR"
  }, {
    quote: "La transparencia y honestidad sobre lo que se puede lograr es lo que más valoro. Resultados reales y sin falsas promesas.",
    author: "MARÍA L.",
    meta: "CONTROL DE CAÍDA"
  }, {
    quote: "El equipo es increíblemente profesional. El ambiente del instituto es privado, elegante y muy acogedor.",
    author: "PEDRO S.",
    meta: "TRATAMIENTO INTEGRAL"
  }, {
    quote: "La Dra. Soto tiene una visión artística y médica única. El resultado final superó todas mis expectativas.",
    author: "ANA B.",
    meta: "CIRUGÍA CAPILAR"
  }];
  React.useEffect(() => {
    if (!api) return;
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    const onSelect = () => setCurrent(api.selectedScrollSnap());
    api.on("select", onSelect);
    api.on("reInit", onSelect);
    return () => {
      api.off("select", onSelect);
    };
  }, [api]);
  return;
}